
export default {
  methods: {
    prepareParam(context, paramName) {
        if (context.model.params[paramName] === undefined || context.model.params[paramName].length === 0) {
          return "";  
        }

        if (!Array.isArray(context.model.params[paramName])) {
          context.model.params[paramName] = [context.model.params[paramName]];
        }

        var retval = JSON.parse(JSON.stringify(context.model.params[paramName]))
        return retval.join("\n");
      },
  }
}
